import React, { Component } from "react";
import { Loader } from "react-loaders";
import { Link } from "react-router";
import { batchRequest } from "../api/ApiService";
import { logError, detectMobile } from "../services/utils";
import Teams from "../api/Teams";
import Auth from "../routes/Auth";
import CollapseImage from "../containers/assets/icon_collapse.svg";
import Kpis1 from "../components/ceo/analysis/competitive/kpis-1";
import Kpis2 from "../components/ceo/analysis/competitive/kpis-2";
import MarketCapture from "../components/ceo/analysis/competitive/market-capture";
import ProductCosts from "../components/ceo/analysis/competitive/product-costs";
import Volume from "../components/ceo/analysis/competitive/volume";
import Utilization from "../components/ceo/analysis/competitive/utilization";
import TopTeams from "../components/ceo/analysis/competitive/top-teams";
import TopProductsMobile from "../components/ceo/analysis/competitive/top-products-mobile";
import TopProductsAuto from "../components/ceo/analysis/competitive/top-products-auto";
import Pricing from "../components/ceo/analysis/competitive/pricing";
import PerceptualMap from "../components/ceo/analysis/competitive/perceptual-map";
import SalesSpending from "../components/ceo/analysis/competitive/sales-spending";
import PromotionalSpend from "../components/ceo/analysis/competitive/promotional-spend";
import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../components/typeform/TypeformContent";
import EventEmitter from "../services/event-emitter";

class CompetitiveAnalysis extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      total_demand: {
        auto: 0,
        mobile: 0
      },
      teams: {},
      top_performers: {},
      metrics: {},
      loaded: false,
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      rounds: props.rounds
    };

    this.eventemitter = EventEmitter.getInstance();
    this.isMobile = detectMobile();
  }

  getCompetitiveAnalysis() {
    const { currentRound, roundInUrl, rounds } = this.state;

    const base_url = `${process.env.REACT_APP_API_URL}competition/competitive_analysis/`;
    let url = "";
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      let round = rounds.find(i => i.number === roundInUrl);
      if (round) {
        url = `${base_url}?round=${round.id}`;
      }
    } else {
      let round = rounds.find(i => i.number === currentRound);
      if (round) {
        if (round.is_finished === true) {
          url = `${base_url}?round=${round.id}`;
        } else {
          const round_number = currentRound - 1;
          if (round_number > 0) {
            round = rounds.find(i => i.number === round_number);
            if (round) {
              url = `${base_url}?round=${round.id}`;
            }
          }
        }
      }
    }

    if (url === "") {
      return null;
    }

    return url;
  }

  getTotalDemand() {
    return `${process.env.REACT_APP_API_URL}static/total_demand/`;
  }

  getTopPerformers() {
    const { currentRound, roundInUrl } = this.state;
    const game_id = Auth.getGameId();
    let round_number = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      round_number = roundInUrl;
    }

    return `${process.env.REACT_APP_API_URL}games/${game_id}/top_performers/?round_number=${round_number}`;
  }

  getCompetitionMetrics() {
    const { currentRound, roundInUrl } = this.state;
    let round_number = currentRound;
    const base_url = `${process.env.REACT_APP_API_URL}competition/metrics/`;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      round_number = roundInUrl;

      return `${base_url}?round_number=${round_number}`;
    }

    return `${base_url}?round_number=${round_number}`;
  }

  componentWillUnmount() {
    if (this.joinRequest) {
      this.joinRequest.abort();
      this.joinRequest = null;
    }
  }

  componentWillReceiveProps(nextProps) {
    let needUpdate = false;
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      needUpdate = true;
    }

    if (this.state.currentRound !== nextProps.currentRound) {
      needUpdate = true;
    }

    if (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
      needUpdate = true;
    }

    const round1 = this.state.rounds.find(
      i => i.number === nextProps.currentRound
    );
    const round2 = nextProps.rounds.find(
      i => i.number === nextProps.currentRound
    );
    if (round1 && round2 && round1.is_finished !== round2.is_finished) {
      needUpdate = true;
    }

    if (needUpdate === true) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  fetchData = () => {
    let teams = {};
    let data = {};

    Teams.teams().forEach(item => {
      teams[item.id] = item.name;
      data[item.id] = {};
    });

    this.setState(
      {
        teams,
        data
      },
      () => {
        this.loadState();
      }
    );
  };

  componentDidMount() {
    this.fetchData();
  }

  getRequests = () => {
    const request1 = this.getCompetitiveAnalysis();
    const request2 = this.getTotalDemand();
    const request3 = this.getTopPerformers();
    const request4 = this.getCompetitionMetrics();

    if (!request1) {
      return null;
    }

    return batchRequest([request1, request2, request3, request4]);
  };

  loadState = () => {
    this.setState({
      loaded: false
    });

    if (this.joinRequest) {
      this.joinRequest.abort();
      this.joinRequest = null;
    }
    this.joinRequest = this.getRequests();

    if (this.joinRequest) {
      this.joinRequest
        .then(res => {
          let data = { ...this.state.data };
          const res0 = res[0].body;
          const res1 = res[1].body;
          const top_performers = res[2].body;
          const competition_metrics = res[3].body;
          const { currentRound, roundInUrl } = this.state;
          const exclude_keys = [
            "created_at",
            "id",
            "is_actual",
            "reason",
            "round",
            "team",
            "updated_at"
          ];

          let metrics = {};
          competition_metrics.forEach(row => {
            metrics[row.team] = {
              MarketShare: row["Market Share"] ? row["Market Share"] : 0,
              Revenues: row["Net Revenues"] ? row["Net Revenues"] : 0,
              GrossMargins: row["Gross Margin"] ? row["Gross Margin"] : 0
            };
          });

          res0.forEach(item => {
            if (item.team in data) {
              Object.keys(item).forEach(key => {
                if (exclude_keys.includes(key)) {
                  return;
                }

                data[item.team][key] = item[key] === null ? 0 : item[key];
              });
            }
          });

          let current_round = currentRound;
          if (roundInUrl !== null && roundInUrl !== currentRound) {
            current_round = roundInUrl;
          }

          const obj = res1.find(i => i.round_number === current_round);
          let total_demand = {
            auto: 0,
            mobile: 0
          };

          if (obj) {
            total_demand.auto = obj.auto;
            total_demand.mobile = obj.mobile;
          }

          this.setState(
            {
              data,
              total_demand,
              top_performers,
              metrics,
              loaded: true
            },
            () => {
              this.joinRequest = null;
            }
          );
        })
        .catch(err => {
          logError(err, "CompetitiveAnalysis", "loadState");
        });
    } else {
      this.setState({
        loaded: true
      });
    }
  };

  get showTopPerformers() {
    const { top_performers } = this.state;
    return Object.keys(top_performers).length > 0;
  }

  get currentYear() {
    const { currentRound, roundInUrl } = this.state;

    let current_year = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_year = roundInUrl;
    }

    return current_year;
  }

  render() {
    const {
      teams,
      data,
      total_demand,
      top_performers,
      loaded,
      metrics,
      roundInUrl,
      currentRound
    } = this.state;
    const currentYear = this.currentYear;
    let url = "/ceo/analysis";
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      url = `/ceo/analysis?round=${roundInUrl}`;
    }

    return (
      <section
        id="ca-wrapper"
        className={"analysis" + (loaded ? " bg-gray" : "")}
      >
        {loaded ? (
          <div className="row">
            <h3 className="h3-icon semibold">
              Competitive Analysis
              <HelpIconButtonWithTooltipAndTypeformModal
                {...TypeformContent.COMPETITIVE_ANALYSIS}
              />
              <Link to={url} className="icon-zoom">
                <img src={CollapseImage} className="icon" alt="CollapseImage" />
              </Link>
            </h3>
            {this.showTopPerformers === true && (
              <div className="competitive-analysis-title-bar">
                TOP PERFORMERS
              </div>
            )}
            {this.showTopPerformers === true && (
              <div className="row">
                <TopTeams teams={teams} top_performers={top_performers} />
                <TopProductsMobile
                  teams={teams}
                  top_performers={top_performers}
                />
                <TopProductsAuto
                  teams={teams}
                  top_performers={top_performers}
                />
              </div>
            )}
            <div className="competitive-analysis-title-bar">LEADING KPIS</div>
            {currentYear <= 4 && (
              <Kpis1 teams={teams} data={data} metrics={metrics} />
            )}
            {currentYear > 4 && <Kpis2 teams={teams} data={data} />}
            <div className="competitive-analysis-title-bar">
              DEMAND ANALYSIS
            </div>
            <MarketCapture
              teams={teams}
              data={data}
              total_demand={total_demand}
            />
            <div className="competitive-analysis-title-bar">
              OPERATIONAL ANALYSIS
            </div>
            <div className="row">
              <ProductCosts teams={teams} data={data} />
              {this.isMobile === false && <Volume teams={teams} data={data} />}
              <Utilization teams={teams} data={data} />
            </div>
            <div className="competitive-analysis-title-bar">MARKETING MIX</div>
            <div className="row">
              <Pricing teams={teams} data={data} />
              <div className="col-md-6 col-xs-12">
                {this.isMobile === false && <PerceptualMap />}
                <SalesSpending teams={teams} data={data} />
              </div>
              <PromotionalSpend teams={teams} data={data} />
            </div>
          </div>
        ) : (
          <Loader type="ball-scale-ripple" active />
        )}
      </section>
    );
  }
}

export default CompetitiveAnalysis;



// WEBPACK FOOTER //
// ./src/containers/competitive-analysis.js